import React, { FC, useEffect, useState } from 'react'
import { Row, Spin } from 'antd'

import { resellerService } from '../../../services'
import { ReportEntry, RequestErrorInterface, RequestErrorObject } from '../../../types'
import { handleError, RealtimeReport, CsvReport } from '../../../components'

interface ReportProps {
	resellerId: number
	resellerName: string
}

const Report: FC<ReportProps> = ({ resellerId, resellerName }) => {
	const [report, setReport] = useState<ReportEntry>()
	const [loading, setLoading] = useState<boolean>(false)

	const handleReportError = (error: RequestErrorInterface): RequestErrorObject => {
		const source = 'Report Error'
		const base = { source, status: error.response.status }

		return { ...base, description: 'There was an unexpected problem when attempting to retrieve the report' }
	}

	useEffect(() => {
		const getData = async () => {
			try {
				setLoading(true)
				const { data } = await resellerService.getReport(resellerId)
				setReport(data)
				setLoading(false)
			} catch (error) {
				handleError(error, handleReportError)
			}
		}

		getData()
	}, [resellerId])

	return (
		<div className='report'>
			{loading ? (
				<Spin className='center' tip='Loading report' />
			) : (
				<>
					<Row type='flex' justify='end' style={{ marginBottom: '1rem' }}>
						<CsvReport entityId={resellerId} entityName={resellerName} type={'reseller'} />
					</Row>
					{report && <RealtimeReport reportEntry={report} />}
				</>
			)}
		</div>
	)
}

export default Report
